export default "__VITE_ASSET__C3vYOML8__"